/*
参数              说明                                          类型                  可选值                         默认值
type            【必须】声明 input 类型                     string                                              'text'
id              id                                          number 或 string
value           value 值                                     any
defaultValue    设置初始默认值                             any
size            控件大小                                        string              {'large','default','small'}     'default'
disabled        是否禁用状态，默认为 false                    bool                                                false
addonBefore     带标签的 input，设置前置标签                   node
addonAfter      带标签的 input，设置后置标签                   node
onPressEnter    按下回车的回调 function(e)
autosize        自适应内容高度，只对 type="textarea" 有效       bool or object  true or { minRows: 2, maxRows: 6 }  false
 */
import React from 'react';
import { findDOMNode } from 'react-dom';
import { Input as AntdInput, Row, Col, Icon } from 'antd';
import SvgIcon from 'SvgIcon';
import Label from './label';
import text from './text';
import { getFormatValue } from '../../helpers/util';
import addEventListener from 'rc-util/lib/Dom/addEventListener';
let Input = null;

export default class InputControl extends React.Component {
  constructor(props) {
    super(props);
    Input = cb.electron.getSharedObject() && cb.rest.terminalType === 2 ? require('../common/KeyboardInput').default : AntdInput;
    const { cStyle, cFormatData } = props;
    let config = null, format = null;
    if (cStyle) {
      try {
        config = JSON.parse(cStyle);
      } catch (e) {
        config = {};
      }
    }
    if (cFormatData) {
      try {
        format = JSON.parse(cFormatData);
      } catch (e) {

      }
    }
    this.state = Object.assign({
      bIsNull: props.bIsNull,
      value: props.defaultValue,
      type: props.type || 'text',
      size: props.size || 'default',
      disabled: props.disabled || false,
      visible: !props.bHidden,
      addonBefore: props.addonBefore || '',
      readOnly: props.readOnly,
      addonAfter: props.addonAfter || '',
      placeholder: props.placeholder || '',
      autosize: props.autosize || false,
      formatbefore:'',// 字符串前缀
      showClear: false,
      err: props.err || '',
      msg: props.msg || '',
      format
    }, config);
    this.onPressEnter = this.onPressEnter.bind(this);
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    if (this.props.focus) {
      if (this.refs.input.refs) {
        this.refs.input.refs.input.focus();
      } else {
        let input = cb.dom(findDOMNode(this.refs.input)).find('input');
        input.length && input[0].focus();
      }
    }
    let UserAgent = navigator.userAgent.toLowerCase();
    this.onMouseDown = addEventListener(document, 'keydown', this.onKeyDown);
    // ipad键盘收起事件,只有ipad 才会有键盘收起事件
    this.onFocusoutDown = /ipad/.test(UserAgent) ? addEventListener(document, 'focusout', this.onFocusout.bind(this)):null;
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
    this.onMouseDown && this.onMouseDown.remove();
    this.onMouseDown = null;
    this.onFocusoutDown && this.onFocusoutDown.remove();
    this.onFocusoutDown = null;
  }
  onKeyDown = (e) => {
    if(e.key == 'Tab' || e.keyCode == '9')
      this.bTabClick = true;
  }
  onFocusout=()=>{
    if(this.refs.input && this.refs.input.refs.input && this.props.model){
      let value = this.refs.input.refs.input.value;
      value = value === '' ? null : value;
      this.props.model.setValue(value, true);
      this.props.model.execute('blur');
    }
  }
  //render前
  componentWillUpdate(nextProps, nextState) {
    if (this.state.focused != nextState.focused && nextState.focused) {
      if (this.refs.input && this.refs.input.refs&& this.refs.input.refs.input) {
        setTimeout(() => {
          this.refs.input.refs.input.focus();
        }, 0)
      }
    }
  }
  //render后
  componentDidUpdate() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  // 监听外部props的变化, 如果变化了需要更新组件的state
  componentWillReceiveProps(nextProps) {
    if (this.props.model) return;
    if (nextProps.defaultValue != this.state.value)
      this.setState({ value: nextProps.defaultValue });
    if (nextProps.err != this.state.err)
      this.setState({ err: nextProps.err })
  }
  handleInputChange(e) {
    // if (this.props.model) {
    //    this.props.model.setData('value', e.target.value);
    // } else {
    // const value = e.target.value;
    // const { iMaxLength } = this.state;
    // if (iMaxLength && value.length > iMaxLength) return;
    const value = e && e.target ? e.target.value : e;
    if (this.props.onChange)
      this.props.onChange(value)
    if (this.props.model)
      if (!this.props.model.execute('valueChange', value)) return
    this.setState({
      value
    });
    // }
  }
  handleInputBlur(e) {
    if(this.state.showClear && !this.bTabClick) return;
    this.bTabClick = false;
    let value = e && e.target ? e.target.value : e;
    value = value === '' ? null : value;
    if (this.props.model) {
      this.props.model.setValue(value, true);
      this.props.model.execute('blur');
    }
    if (this.props.onBlur) {
      this.props.onBlur(value);
    }
    this.setState({ focused: false });
  }
  handleInputFocus(e) {
    if (e && e.target)
      e.target.setSelectionRange(0, e.target.value.length);
    if (this.props.model) {
      this.props.model.execute('focus');
    }
    this.setState({ focused: true })
  }
  onPressEnter(e) {
    let value = e && e.target ? e.target.value : e;
    value = value === '' ? null : value;
    if (this.props.model) {
      this.props.model.setValue(value, true, true);
      this.props.model.execute('enter');
    }
    if (this.props.onSearch)
      this.props.onSearch(value);
  }
  validate(val) {
    this.setState({
      err: 'has-' + val.type,
      msg: val.message
    });
  }
  onMouseEnter = () => {
    this.setState({ showClear: true });
  }
  onMouseLeave = () => {
    this.setState({ showClear: false });
  }
  emitEmpty = () => {
    const { model } = this.props;
    if(model){
      model.setValue(null, true);
    }else{ // 在未传入model 的时候，组件本身的值与model 无关 fixed by donghym
      this.setState({value:null});
    }
    if (!model || !model.execute('valueChange', null))return;
    this.setState({value:null});
    // model.setValue(null, true);
    if (this.refs.input && this.refs.input.refs) {
      setTimeout(() => {
        this.refs.input.refs.input.focus();
      }, 0)
    }
  }
  baseControl() {
    const { readOnly, value, type, placeholder, size, disabled, addonBefore, addonAfter, format, iMaxLength, icon, formatbefore,before, after, bottom, focused, showClear } = this.state;
    let showValue = value, prefix = null, suffix = null;
    if (format) {
      const formatValue = getFormatValue(value, format);
      showValue = formatValue.showValue;
      prefix = formatValue.prefix;
      suffix = formatValue.suffix;
    }
    if (readOnly){
      let fontColor = this.state.fontColor ? <span style={{color:this.state.fontColor}}>{showValue}</span> : showValue;
      return (before || formatbefore || after) ? <div className="input-hasBA">
        {before ? <span className="input-before">{before}</span> :null}
        {formatbefore ? <span className="input-formatbefore-readonly">{formatbefore}</span> :null}
        {text(fontColor)}
        {after ? <span className="input-after">{after}</span> :null}
      </div> :
      text(fontColor);
    }
    if (icon)
      suffix = <SvgIcon type={icon} />
    if (this.props.onSearch)
      suffix = <Icon type='search' onClick={() => this.props.onSearch(value)} />
    if (!disabled) {
      const suffixItems = [];
      if (value && (showClear || focused))
        suffixItems.push(<Icon type="close-circle" onClick={this.emitEmpty} />);
      suffixItems.push(suffix);
      suffix = <div>{suffixItems}</div>
    }
    const props = {
      autoComplete: 'new-password',
      ref: 'input',
      type,
      placeholder: placeholder,
      size: size,
      disabled: disabled,
      addonBefore: addonBefore,
      addonAfter: addonAfter,
      onPressEnter: this.onPressEnter,
      value: cb.utils.isEmpty(value) ? '' : value,
      prefix,
      suffix,
      onBlur: e => this.handleInputBlur(e),
      onChange: e => this.handleInputChange(e),
      onFocus: e => this.handleInputFocus(e)
    };
    if (iMaxLength)
      props.maxLength = iMaxLength;
    if (focused)
      props.className = "input_focused";
      let fontColor = this.state.fontColor ? this.state.fontColor :'';
      let refInput = this.refs.input;
      // if(this.refs == {}) return;
      // else{
      //   if(this.refs && this.refs.input.refs ) {
      //     this.refs.input.refs.input.style.color = fontColor
      //   }
      // }
      if(refInput && refInput.refs && refInput.refs.input && refInput.refs.input.style){
        refInput.refs.input.style.color = fontColor
      }
    const com = <Input {...props}/>
    if (!after && !bottom && !before && !formatbefore)
      return com;
    return (
      <div className="input-bottom">
        <div>
          {formatbefore && <span className='input-formatbefore'>{formatbefore}</span>}
          {before && <span className="input-before">{before}</span>}
          {com}{after && <span className="input-after">{after}</span>}
        </div>
        {bottom && <div className="input-bottom-text">{bottom}</div>}
      </div>
    );
  }
  relatedControl() {
    const control = this.baseControl();
    const { relatedControl } = this.props;
    if (!relatedControl)
      return control;
    return (
      <div className='has-related'>
        <div className='viewCell'>{control}</div>
        {relatedControl}
      </div>
    );
  }
  getControl() {
    let cShowCaption = this.props.cShowCaption;
    if(cShowCaption && cShowCaption != this.state.cShowCaption && this.props.source != 'filterchart') cShowCaption = this.state.cShowCaption;
    const title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
    let control = ((cShowCaption && !this.props.hideTitle) ? <Label control={this.relatedControl()} title={title} /> : this.relatedControl());
    return control;
  }
  render() {
    const control = this.getControl();
    let style = this.state.visible ? {} : { display: "none" };
    let errClass = `basic-input-${this.state.type} has-feedback ${this.state.classname || ''} ` + this.state.err;
    return (
      <div style={style} className={errClass} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        {control}
        <div className="ant-form-explain">{this.state.msg}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/input.jsx